import { Button as SuperAdminButton } from '../../../../baseComponents';
import { SuperAdminTable } from '../../../../baseComponents/Table';

type WorkflowTemplateRecord = {
  key: string;
  workflow_template_id: string;
  name: string;
  description?: string;
  workflow: Record<string, unknown>;
  created_at?: string;
  updated_at?: string;
};

type WorkflowTemplatesTabProps = {
  hasOrgSelected: boolean;
  onCreateTemplate: () => void;
  workflowTemplateTableData: WorkflowTemplateRecord[];
  templateColumns: any;
  isLoadingTemplates: boolean;
  isFetchingTemplates: boolean;
};

const SuperAdminButtonBase = SuperAdminButton as any;
const SuperAdminTableBase = SuperAdminTable as any;

export const WorkflowTemplatesTab = ({
  hasOrgSelected,
  onCreateTemplate,
  workflowTemplateTableData,
  templateColumns,
  isLoadingTemplates,
  isFetchingTemplates,
}: WorkflowTemplatesTabProps) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <SuperAdminButtonBase
          type="button"
          onClick={onCreateTemplate}
          disabled={!hasOrgSelected}
        >
          Create Workflow Template
        </SuperAdminButtonBase>
      </div>
      <div className="ant-table rounded-xl shadow-xl">
        <SuperAdminTableBase
          className="appointment-page-table"
          data={workflowTemplateTableData}
          columns={templateColumns}
          loading={isLoadingTemplates || isFetchingTemplates}
        />
      </div>
    </div>
  );
};
